jQuery(document).ready(function($) {
    if($('body.single-offices').length && $('select[name="country"]')) {
        urlSlug = window.location.pathname.split("/").pop();
        var formattedSlug = urlSlug.replace(/-/g, ' ');

        var valueToSet = $('select[name="country"] option').filter(function() {
            return $(this).text().toLowerCase() === formattedSlug.toLowerCase(); 
        }).val();            
        if(valueToSet) {
            $('select[name="country"]').val(valueToSet);
        }
    }

    $('[data-anchor]').on('click', function(e) {
        e.preventDefault(); 
    
        var target = $(this).attr('data-anchor'); 
    
        if (target) {
            
            $('html, body').animate({
                scrollTop: $('#' + target).offset().top -100
            }, 800); 
        }
    });
    
});